/**
 * Accua Cookie Consent - bootstrap
 *
 * PHP prints this inline right after the dialog markup, at the top of <body>
 * (accua_cookie_consent_ui_html()), so it runs while the page is still being parsed,
 * before the dialog's first paint and before any parser-blocking script of the page.
 * The rest of the plugin (accua-cookie.min.js) is deferred and can arrive seconds
 * later on a slow phone; deciding here lets the dialog paint with the page instead of
 * appearing late, which made it the Largest Contentful Paint on light pages.
 *
 * The page HTML is the same for every visitor (it is cached), so everything that
 * depends on the visitor is decided here, in the browser:
 *  - crawlers ("Salta il banner per i motori di ricerca"): the user agent is matched
 *    against the list PHP uses (accua_cookie_get_bot_patterns()); no dialog;
 *  - the dialog language: the first navigator language the site offers, else the
 *    fallback. The page carries the dialog in one language; for another one, that
 *    language's pack (a static file, accua_cookie_language_packs()) is loaded first
 *    and its texts are swapped in before the dialog shows;
 *  - the consent cookie: no dialog for a visitor who already chose, unless
 *    categories were added since.
 * Clicks on the dialog before the main script is ready are queued for it (and the
 * dialog hides at once for Accept / Confirm / Close). If the main script never
 * arrives (blocked by an ad blocker, a network error), the dialog is hidden at
 * page load, which is what visitors without the script got before.
 *
 * Also part of accua-cookie.min.js, which runs it when this inline copy did not
 * run (stripped or delayed by an optimiser).
 *
 * State shared with the main script: window.accuaCookieBoot.
 *
 * @since 6.8.0
 */
(function (w, d) {
    'use strict';

    var CLOSING = { 'accua-modal-accept': 1, 'accua-modal-confirm': 1, 'accua-modal-close': 1 };
    var ACTIVE = 'accua-modal-active';

    function has(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
    }

    function addClass(el, cls) {
        if (el) {
            el.classList.add(cls);
        }
    }

    function removeClass(el, cls) {
        if (el) {
            el.classList.remove(cls);
        }
    }

    /**
     * Swap in the dialog texts of a language pack.
     *
     * The markup carries markers where its text depends on the language
     * (data-accua-h: inner HTML, data-accua-a: attributes); a pack holds exactly
     * what PHP printed there when it rendered that language.
     */
    function applyStrings(pack) {
        var els = d.querySelectorAll('[data-accua-h]');
        var i, j, key;
        for (i = 0; i < els.length; i++) {
            key = els[i].getAttribute('data-accua-h');
            if (pack.h && has(pack.h, key)) {
                els[i].innerHTML = pack.h[key];
            }
        }
        els = d.querySelectorAll('[data-accua-a]');
        for (i = 0; i < els.length; i++) {
            var pairs = els[i].getAttribute('data-accua-a').split(' ');
            for (j = 0; j < pairs.length; j++) {
                var sep = pairs[j].indexOf(':');
                var attr = pairs[j].substring(0, sep);
                key = pairs[j].substring(sep + 1);
                if (attr && pack.a && has(pack.a, key)) {
                    if (pack.a[key] === false) {
                        els[i].removeAttribute(attr);
                    } else {
                        els[i].setAttribute(attr, pack.a[key]);
                    }
                }
            }
        }
    }

    function run() {
        if (w.accuaCookieBoot) {
            return w.accuaCookieBoot;
        }
        var c;
        try {
            c = JSON.parse(d.getElementById('accua-cookie-config').textContent);
        } catch (e) {
            return null; // no config: legacy markup, the main script handles it
        }

        var html = d.documentElement;
        var i;
        var boot = w.accuaCookieBoot = { config: c, queue: [], ready: false, opened: false, bot: false };
        var packs = w.accuaCookiePacks = w.accuaCookiePacks || {};
        var pending = {};
        var waiting = [];

        /**
         * Load the pack of a language (static file, else the endpoint) and call
         * back with it, or with null when neither answered within 6 seconds.
         * urgent: the dialog waits for it to show, so fetch it ahead of the
         * page's images and other late requests (a script added this way is
         * otherwise fetched at low priority).
         */
        boot.pack = function (lang, cb, urgent) {
            if (packs[lang]) {
                cb(packs[lang]);
                return;
            }
            if (pending[lang]) {
                pending[lang].push(cb);
                return;
            }
            var callbacks = pending[lang] = [cb];
            var p = c.packs || {};
            var hash = (p.h && p.h[lang]) || '';
            var urls = [];
            if (p.u && hash) {
                urls.push(p.u + 'pack-' + lang + '-' + hash + '.js');
            }
            if (p.f) {
                urls.push(p.f.replace('__LANG__', encodeURIComponent(lang)).replace('__V__', encodeURIComponent(hash)));
            }
            var timer;
            var finish = function () {
                if (pending[lang] === callbacks) {
                    clearTimeout(timer);
                    delete pending[lang];
                    for (var k = 0; k < callbacks.length; k++) {
                        callbacks[k](packs[lang] || null);
                    }
                }
            };
            var attempt = function (n) {
                if (packs[lang] || n >= urls.length) {
                    finish();
                    return;
                }
                var s = d.createElement('script');
                s.src = urls[n];
                s.async = true;
                if (urgent) {
                    s.fetchPriority = 'high';
                }
                s.onload = function () {
                    attempt(packs[lang] ? n : n + 1);
                };
                s.onerror = function () {
                    attempt(n + 1);
                };
                (d.head || html).appendChild(s);
            };
            timer = setTimeout(finish, 6000);
            attempt(0);
        };

        /** Run fn once the dialog speaks the visitor's language. */
        boot.whenReady = function (fn) {
            if (boot.langReady) {
                fn();
            } else {
                waiting.push(fn);
            }
        };

        // Crawler? (only listed when "skip bots" is on)
        var ua = String(navigator.userAgent || '').toLowerCase();
        for (i = 0; c.bots && i < c.bots.length; i++) {
            if (ua.indexOf(c.bots[i]) !== -1) {
                boot.bot = true;
                break;
            }
        }

        // Language: the first browser language the site offers, else the fallback
        var nav = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language || ''];
        boot.lang = c.fb || c.il;
        for (i = 0; i < nav.length; i++) {
            var two = String(nav[i] || '').toLowerCase().substring(0, 2);
            if (c.langs.indexOf(two) !== -1) {
                boot.lang = two;
                break;
            }
        }

        // Consent: decided when the cookie names every active category
        boot.cookie = null;
        var cookies = d.cookie ? d.cookie.split('; ') : [];
        for (i = 0; i < cookies.length; i++) {
            var eq = cookies[i].indexOf('=');
            if (cookies[i].substring(0, eq) === 'accuaCookieConsent') {
                try {
                    boot.cookie = decodeURIComponent(cookies[i].substring(eq + 1));
                } catch (e) {
                    boot.cookie = cookies[i].substring(eq + 1);
                }
                break;
            }
        }
        var decided = false;
        if (boot.cookie) {
            var names = {};
            var parts = boot.cookie.split('|');
            for (i = 0; i < parts.length; i++) {
                names[parts[i].split(':')[0]] = 1;
            }
            decided = true;
            var classes = (c.core && c.core.classesData) || {};
            for (var k in classes) {
                if (has(classes, k) && !has(names, classes[k].name)) {
                    decided = false;
                    break;
                }
            }
        }

        if (boot.bot) {
            addClass(html, 'accua-cc-bot');
        }
        if (!boot.cookie) {
            addClass(html, 'accua-cc-undecided');
        }

        var modal = d.getElementById('accua-modal-modal');
        var backdrop = d.getElementById('accua-modal-backdrop');

        // The dialog must be a direct child of <body>: the main script makes
        // every other child of <body> inert while it is open, and a fixed
        // element inside a transformed ancestor is not positioned against the
        // viewport. Themes that call wp_body_open() (or, for the footer
        // fallback, wp_footer()) inside a wrapper would break both (the
        // previous <template> clone was always appended to <body>).
        if (modal && d.body && modal.parentNode !== d.body) {
            var moved = [backdrop, modal, d.getElementById('accua-modal-announcer')];
            for (i = 0; i < moved.length; i++) {
                if (moved[i]) {
                    d.body.appendChild(moved[i]);
                }
            }
        }

        boot.hide = function () {
            boot.opened = false;
            removeClass(modal, ACTIVE);
            removeClass(backdrop, ACTIVE);
            removeClass(html, 'accua-cc-preopen');
        };

        if (modal && !boot.bot && !decided && !(c.core && c.core.popupDisabled === '1')) {
            boot.opened = true;
            addClass(html, 'accua-cc-preopen');
            // Shown in the same frame the page first paints. The entry
            // transition still plays: css/style.css gives the active state an
            // @starting-style (browsers without it show the dialog without the
            // fade). Waiting a frame or two for a plain transition instead lets
            // Lighthouse tie the dialog's paint, often the largest on the page,
            // to whatever scripts ran meanwhile.
            //
            // While the visitor's language pack loads, the dialog is kept out
            // of rendering altogether (display: none), so that showing it is
            // still its first render and the same entry transition applies.
            // Shown from its rendered hidden state instead, the plain
            // transition flips visibility, a change the compositor cannot
            // animate: the browser repaints the dialog on the main thread a
            // frame later, and Chrome reports that repaint, mid-load, as the
            // Largest Contentful Paint.
            modal.style.display = 'none';
            if (backdrop) {
                backdrop.style.display = 'none';
            }
            boot.whenReady(function () {
                modal.style.display = '';
                if (backdrop) {
                    backdrop.style.display = '';
                }
                if (boot.opened) {
                    addClass(modal, ACTIVE);
                    addClass(backdrop, ACTIVE);
                }
            });

            // Until the main script takes over, remember what the visitor does
            modal.addEventListener('click', function (e) {
                if (boot.ready || !boot.opened) {
                    return;
                }
                var t = e.target;
                while (t && t !== modal && t.nodeName !== 'BUTTON' && t.nodeName !== 'A') {
                    t = t.parentNode;
                }
                if (!t || t === modal) {
                    return;
                }
                var id = t.id || '';
                if (CLOSING[id]) {
                    e.preventDefault();
                    boot.queue.push({ id: id });
                    boot.hide();
                } else if (id === 'accua-modal-more-link' || t.classList.contains('accua-modal-info-btn') ||
                    (id === 'accua-modal-privacy-link' && t.getAttribute('href') === '#')) {
                    e.preventDefault();
                    boot.queue.push({ id: id, category: t.getAttribute('data-category') });
                }
            }, true);
            d.addEventListener('keydown', function (e) {
                // Only once the dialog is on screen: not while its language
                // pack is still loading
                if (!boot.ready && boot.opened && modal.classList.contains(ACTIVE) && (e.key === 'Escape' || e.keyCode === 27)) {
                    boot.queue.push({ id: 'accua-modal-close' });
                    boot.hide();
                }
            }, true);

            // Safety net: by the load event the main script has run unless it
            // was blocked or failed; never leave a dialog nobody can operate.
            w.addEventListener('load', function () {
                if (!w.AccuaAccessibleModal && boot.opened) {
                    boot.hide();
                }
            });
        }

        var langReady = function () {
            boot.langReady = true;
            for (var n = 0; n < waiting.length; n++) {
                waiting[n]();
            }
            waiting = [];
        };
        // No packs (legacy banner): its strings are all in the config
        if (boot.lang === c.il || !c.packs) {
            langReady();
        } else {
            boot.pack(boot.lang, function (pack) {
                if (pack) {
                    applyStrings(pack);
                } else {
                    boot.lang = c.il; // keep the page's language rather than no dialog
                }
                langReady();
            }, boot.opened);
        }

        return boot;
    }

    w.accuaCookieBootRun = run;
})(window, document);
